export default __webpack_public_path__ + "static/media/21.f9984b89.jpg";